import _regeneratorRuntime from 'babel-runtime/regenerator';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import BaseSubscriptionService from './BaseSubscriptionService';
import apex from '../../apex';
var OrderTradesSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(OrderTradesSubscriptionService, _BaseSubscriptionServ);
  function OrderTradesSubscriptionService() {
    _classCallCheck(this, OrderTradesSubscriptionService);
    return _possibleConstructorReturn(this, (OrderTradesSubscriptionService.__proto__ || Object.getPrototypeOf(OrderTradesSubscriptionService)).apply(this, arguments));
  }
  _createClass(OrderTradesSubscriptionService, [{
    key: 'initSubscribtion',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        var AccountId, OMSId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                AccountId = options.AccountId, OMSId = options.OMSId;
                apex.connection.subscribeAccountEvents(AccountId, OMSId);
              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function initSubscribtion(_x) {
        return _ref.apply(this, arguments);
      }
      return initSubscribtion;
    }()
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();
      this.subscription = apex.connection.ws.filter(function (x) {
        return x.n === 'OrderTradeEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);
  return OrderTradesSubscriptionService;
}(BaseSubscriptionService);
export default new OrderTradesSubscriptionService();